// Open a Stripe (or other external) checkout URL.
// Inside the Telegram Mini App, use the system browser for a reliable payment flow.
export const openCheckout = (url) => {
  const tg = window.Telegram?.WebApp;
  if (tg?.initData && typeof tg.openLink === 'function') {
    tg.openLink(url);
  } else {
    window.location.href = url;
  }
};
